enum RouteEnum {
  Home = '/home',
  CreateQuestionnaire = '/create-questionnaire',
  Login = '/',
  ListQuestionnaire = '/list-questionnaire',
  ViewAduit = '/viewAduit',
}

export default RouteEnum;
